import { isInvalidDate } from '../utils/is';

export function transformDate(date: string | number | Date) {
  const newDate = new Date(date);

  if (isInvalidDate(newDate)) {
    return;
  }

  return `${newDate.getFullYear()}-${
    newDate.getMonth() + 1
  }-${newDate.getDate()}`;
}
